import React from 'react';
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Link
} from 'react-router-dom'

import './App.css';
import {
  Home,
  Music,
  Pictures,
  PsanckPromo,
  TwentyFour,
  Video,
  Writing,
  Chess
} from './pages'

function App() {
  return (
    <Router>
      <div>
        <nav>
          <ul className="navbar">
            <li>
              <Link to="/">Home</Link>
            </li>
            <li>
              <Link to="/music">Music</Link>
            </li>
            <li>
              <Link to="/pictures">Pictures</Link>
            </li>
            <li>
              <Link to="/video">Video</Link>
            </li>
            <li>
              <Link to="/writing">Writing</Link>
            </li>
            <li>
              <Link to="/writing">Writing</Link>
            </li>
          </ul>
        </nav>
        <Switch>
          <Route exact path="/">
            <Home />
          </Route>
          <Route path="/music">
            <Music/>
          </Route>
          <Route path="/psanck">
            <PsanckPromo/>
          </Route>
          <Route path="/pictures">
            <Pictures/>
          </Route>
          <Route path="/twenty-four">
            <TwentyFour />
          </Route>
          <Route path="/video">
            <Video/>
          </Route>
          <Route path="/writing">
            <Writing/>
          </Route>
          <Route path="/chess">
            <Chess/>
          </Route>
        </Switch>
      </div>
    </Router>
      );
}

export default App;
